import React from 'react';
import FooterJSX from './Footer.jsx';
import './Footer.css';

const Footer = () => {
    return <FooterJSX/>;
};

export default Footer;